const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "register":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "register",
    reducer: reducer,
};

export default data;
